import { Link } from 'react-router-dom'

const previewImages = [
  {
    title: 'Weekly Drops',
    subtitle: 'Fresh puzzles curated by the community.',
    src: '/images/phone-1.png',
  },
  {
    title: 'Vote to Unlock',
    subtitle: 'Upvote your favourites and decide what goes free next.',
    src: '/images/phone-2.png',
  },
  {
    title: 'Play Anywhere',
    subtitle: 'Mobile-first experience with offline wordlists.',
    src: '/images/featureGraphic.png',
  },
]

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-950 to-indigo-900 text-slate-50">
      <div className="max-w-6xl mx-auto px-4 py-16 md:py-20">
        <header className="flex flex-col md:flex-row md:items-center md:justify-between gap-10">
          <div className="max-w-2xl space-y-4">
            <p className="text-sm uppercase tracking-[0.2em] text-indigo-300">Ciphergrid</p>
            <h1 className="text-4xl md:text-5xl font-bold leading-tight">
              Word puzzles, curated by players. <span className="text-indigo-300">Coming soon.</span>
            </h1>
            <p className="text-lg text-slate-200/80">
              Weekly drops, procedurally generated grids, and a store shaped by community votes. Sign in to manage content,
              or check back when we launch the public app.
            </p>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/admin"
                className="px-6 py-3 bg-indigo-500 hover:bg-indigo-400 text-slate-900 font-semibold rounded-lg transition shadow-lg shadow-indigo-900/40"
              >
                Admin sign-in
              </Link>
              <a
                href="#updates"
                className="px-6 py-3 border border-indigo-300/60 hover:border-indigo-200 text-indigo-100 rounded-lg transition"
              >
                Get launch updates
              </a>
            </div>
          </div>
          <div className="flex-1">
            <div className="overflow-hidden rounded-2xl border border-slate-800 shadow-2xl shadow-indigo-900/40">
              <img
                src="/images/icon.png"
                alt="Ciphergrid app icon"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </header>

        <section className="mt-16 grid md:grid-cols-3 gap-6">
          {previewImages.map((item) => (
            <div
              key={item.title}
              className="bg-slate-900/70 border border-slate-800 rounded-xl overflow-hidden shadow-lg shadow-black/30"
            >
              <img src={item.src} alt={item.title} className="w-full h-40 object-cover" />
              <div className="p-5 space-y-2">
                <h3 className="text-xl font-semibold text-slate-50">{item.title}</h3>
                <p className="text-sm text-slate-200/70">{item.subtitle}</p>
              </div>
            </div>
          ))}
        </section>

        <section id="updates" className="mt-16 bg-slate-900/70 border border-slate-800 rounded-2xl p-6 md:p-8">
          <div className="md:flex md:items-center md:justify-between gap-6">
            <div className="space-y-2">
              <h2 className="text-2xl font-semibold text-slate-50">Launching soon on Google Play and Apple App Store</h2>
              <p className="text-slate-200/80 max-w-2xl">
                We’re polishing the puzzle catalog and voting flows. In the meantime, admins can sign in to manage drops and pricing.
              </p>
            </div>
            <a
              href="mailto:hello@ciphergrid.app"
              className="mt-4 md:mt-0 inline-flex items-center gap-2 px-5 py-3 bg-indigo-500 hover:bg-indigo-400 text-slate-900 font-semibold rounded-lg transition shadow-lg shadow-indigo-900/40"
            >
              Contact us
            </a>
          </div>
        </section>

        <section className="mt-8 bg-slate-900/70 border border-slate-800 rounded-2xl p-5 space-y-3">
          <h3 className="text-lg font-semibold text-slate-100">Recent Updates</h3>
          <div className="bg-slate-900/60 border border-slate-800 rounded-lg divide-y divide-slate-800">
            {[
              { title: 'Backend hardening', detail: 'Tuning auth, payments, and admin flows for launch.' },
              { title: 'Offline wordlists', detail: 'Packaging curated lists for mobile-first play.' },
              { title: 'Voting UX polish', detail: 'Refining the weekly drop experience and visibility.' },
            ].map((item) => (
              <div key={item.title} className="px-4 py-3 flex items-start gap-3">
                <span className="mt-1 h-2 w-2 rounded-full bg-indigo-400 flex-shrink-0" />
                <div>
                  <p className="text-sm font-semibold text-slate-100">{item.title}</p>
                  <p className="text-sm text-slate-200/70">{item.detail}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        <footer className="mt-16 border-t border-slate-800 pt-6 text-center text-slate-300/80 space-y-3">
          <p className="font-semibold text-base">
            The Promised Clan presents CIPHERGRID, a game by{' '}
            <a href="https://nameunder.review" className="text-indigo-300 hover:text-indigo-200 underline">
              Name Under Review
            </a>
            .
          </p>
          <p className="text-xs">
            <a href="https://thepromisedclan.com" className="text-indigo-300 hover:text-indigo-200 underline">
              The Promised Clan
            </a>{' '}
            is the trading name of THE PROMISED CLAN LIMITED, a company registered in England &amp; Wales (No. 16843890).
            Registered office: 71-75 Shelton Street, Covent Garden, London WC2H 9JQ. Email:{' '}
            <a href="mailto:hello@thepromisedclan.com" className="text-indigo-300 hover:text-indigo-200 underline">
              hello@thepromisedclan.com
            </a>
            .
          </p>
          <div className="flex justify-center gap-4 text-xs">
            <Link to="/privacy" className="text-indigo-300 hover:text-indigo-200 underline">
              Privacy Policy
            </Link>
            <span className="text-slate-600">•</span>
            <Link to="/terms" className="text-indigo-300 hover:text-indigo-200 underline">
              Terms of Service
            </Link>
          </div>
        </footer>
      </div>
    </div>
  )
}
